import { RouteHttpVerb } from "@devowl-wp/utils";
export const locationRestTemplatesBlockersGet = {
    path: "/templates/blocker",
    method: RouteHttpVerb.GET
};
